import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom";
import styled from "styled-components";
import { getNavigatorLocale } from "./FlyerLocalePicker";
import { Spacer } from "./editor/EditorHelpers";


export enum FlyerType {
  BOYCOTT = 'boycott',
  EUROPE = 'europe',
  GREEN = 'green',
  BROCHURE = 'brochure',
  STAR_STICKER = 'star-sticker',
  EURO_STICKER = 'euro-sticker'
}

export default function FlyerTypePicker() {
  const { t, i18n } = useTranslation();
  const navigatorLocale = getNavigatorLocale();
  const country = navigatorLocale.length >= 5 ? navigatorLocale.slice(-2) : null;
  const lang = i18n.language.slice(0, 2);

  const boycottThumb = country === "CA"
    ? "/boycott_thumb_ca.png"
    : "/boycott_thumb.png";

  return (
    <div className="generic-page">
      <div className="narrow-content">
        <h1>{t('customise-a-flyer.title')}</h1>
        <Column>
          <PortraitRow>
            <Link to="pick-language/boycott">
              <img src={boycottThumb} alt="Boycott Flyer Type" />
            </Link>
            <Link to="pick-language/europe">
              <img src="europe_thumb.png" alt="Europe Flyer Type" />
            </Link>
            <Link to="quitting-facebook">
              <img src={`/${lang}/quitting_facebook_thumb.png`} alt="Quitting Facebook Flyer Type" />
            </Link>
          </PortraitRow>
          <LandscapeRow>
            <Link to="pick-language/green">
              <img src="green_thumb.jpg" alt="Green Flyer Type" />
            </Link>
            <Link to="pick-language/brochure">
              <img src="brochure_thumb.png" alt="Brochure Type" />
            </Link>
          </LandscapeRow>
        </Column>
        <Spacer $height="1.5rem" />
        <h1>{t('buy-merch.title')}</h1>
        <Column>
          <LandscapeRow>
            <Link to="https://hardno.tpopsite.com" target="_blank">
              <img src="store_illustration.png" alt="Hardno store" />
            </Link>
          </LandscapeRow>
        </Column>
        <Spacer $height="1.5rem" />
        <h1>{t('design-a-sticker.title')}</h1>
        <Column>
          <SquareRow>
            <Link className="circular" to="pick-language/star-sticker">
              <img className="circular" src={`/${lang}/star_sticker.jpg`} alt="Star-sticker Flyer Type" />
            </Link>
            <Link className="circular" to="pick-language/euro-sticker">
              <img className="circular" src={`/${lang}/euro_sticker.png`} alt="Euro-sticker Flyer Type" />
            </Link>
          </SquareRow>
        </Column>
      </div>
    </div>
  )
}

const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`

const PortraitRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;

  a {
    width: 160px;
    margin: 0 auto;
    height: 226px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  img {
    width: 100%;
    border-radius: 10px;
  }
`

const LandscapeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;

  a {
    width: 226px;
    margin: 0 auto;
    height: 160px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  img {
    width: 100%;
    border-radius: 10px;
  }
`

const SquareRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;

  a {
    width: 160px;
    margin: 0 auto;
    height: 160px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }

  .circular {
    border-radius: 80px;
  }

  img {
    width: 100%;
    border-radius: 10px;
  }
`

/*
.thumbnail-picker-container {
  text-align: center;
}

.thumbnail-picker-container a {
  display: inline-block;
  width: 200px;
  margin: 10px;
  height: 283px;  
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}

.thumbnail-picker-container img {
  width: 100%;
  border-radius: 10px;
}

*/